<template>
  <div class="editInformPage" id="editInformPage">
    <van-cell-group class="forestInput">
      <van-field :label="$t('common.title')" v-model="informMsg.title" :placeholder="$t('common.contentTip')" clearable required />
    </van-cell-group>

    <!-- 富文本编辑 -->
    <van-cell-group required class="historyMain ggMainEditor">
      <van-field required :label="$t('common.content')+'：'" readonly />
      <div class="richText">
        <p class="historyDetail ggMainDetail" v-html="informMsg.content" @click="getRichText()"></p>
        <span class="contentPlaceholder">{{contentPlaceholder}}</span>
      </div>
    </van-cell-group>
    <!-- 上传附件 -->
    <div class="uploadingFiles" v-if="this.clientType == 'android'">
      <h4>{{$t('common.affixTit')}}</h4>
      <a href="javascript:void(0);" @click="uploadFile">{{$t('common.upAffixTit')}}</a>
      <div class="listItem" v-if="informMsg.baseFiles.length > 0">
        <van-cell v-for="(item,index) in informMsg.baseFiles" :key="index" class="item">
          <dl class="fl">
            <dt>
              <img
                :src=" getFormat(item.fileName) == 'jpg' || getFormat(item.fileName) == 'png' || getFormat(item.fileName) == 'jpeg'  ? item.url : getFormat(item.fileName) == 'pdf' ? ''+baseUrl+'searchImg/pdf.png' : getFormat(item.fileName) == 'xlsx' || getFormat(item.fileName) == 'xls' ? ''+baseUrl+'searchImg/excel.png' : ''+baseUrl+'searchImg/word.png'"
                alt
              />
            </dt>
            <dd class="dtName">{{item.fileName}}</dd>
            <dd class="Mb">
              <span>{{getMb(item.fileSize)}}</span>
            </dd>
          </dl>
          <a href="javascript:void(0);" class="deleteBtn fr" @click="setDelete(index)">
            <van-icon name="delete" />
          </a>
        </van-cell>
      </div>
    </div>
    <!-- 弹出层 富文本编辑 -->
    <van-popup v-model="showRichTextPicker" position="bottom" class="clssifyPicker">
      <add-text
        :textSource="RichTextData"
        @getData="changeMain"
        :propsImgs="textImgs"
        :selecRightType="selecRightType"
        :selecLeftType="selecLeftType"
      ></add-text>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/

import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState } from "vuex";
const addText = () => import("@/components/common/addText");
export default {
  name: "editInform",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      informMsg: {
        title: "",
        content: "",
        baseFiles: [] //数组列表
      },
      contentPlaceholder:'',
      RichTextData: {},
      showRichTextPicker: false,
      textImgs: {}, //传递子组件图片
      addType: true,
      selecRightType: "", //更改App右上角值
      selecLeftType: "", //更改App左上角值
      clientType: ""
    };
  },
  components: {
    addText
  },
  mounted() {
    document.title = "通知";
    window.setFile = this.setFiles; //app返回图片回调
    window.onRightClicked = this.addInform; //保存/新增通知
    window.onLeftClicked = this.cancelText; //取消富文本编辑
    this.clientType = getDeviceType();
   this.contentPlaceholder = this.$t('common.contentTip')
    this.initAndroid();
  },
  methods: {
    initAndroid() {
      if (this.clientType == "android") {
        window.android.getInfo(111, this.$t('common.issueTit'));
      }
    },
    //富文本编辑
    getRichText() {
      let _this = this;
      _this.RichTextData.count = _this.informMsg.content;
      _this.showRichTextPicker = true;
      if (this.clientType == "android") {
        window.android.getInfo(111, this.$t('common.save')); 
        window.android.getInfo(112, this.$t('common.cancel')); 
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("1");
      }
    },
    //富文本编辑回调
    changeMain(data) {
      let _this = this;
      _this.showRichTextPicker = false;
      if (this.clientType == "android") {
        window.android.getInfo(111,this.$t('common.issueTit'));
        window.android.getInfo(112, "");
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("2");
      }
      if(data.count != ''){
        _this.contentPlaceholder = '';
      }
      _this.informMsg.content = data.count;
      _this.selecRightType = "";
      _this.selecLeftType = "";
    },
    uploadFile() {
      //点击添加附件
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      let arr = [];
      if (data.code == "101") {
        arr.push(data);
        this.informMsg.baseFiles = this.informMsg.baseFiles.concat(arr);
      } else {
        this.textImgs = data;
      }
    },
    getMb(Kb) {
      //kb转换Mb
      let size = "";
      size = (Kb / 1024 / 1024).toFixed(2) + "MB";
      return size;
    },
    setDelete(index) {
      //删除上传的文件
      this.informMsg.baseFiles.splice(index, 1);
    },
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    addInform(changeType) {
      this.selecRightType = changeType;
      if (changeType == this.$t('common.issueTit') ||  this.clientType=="IOS") {
        //编辑保存/新增通知
        if (this.addType) {
          this.addType = false;
          if (this.informMsg.title == "") {
            this.addType = true;
            this.$toast(this.$t('inform.titToastText'));
            return;
          }
          if (
            this.informMsg.content == this.$t('common.contentTip') ||
            this.informMsg.content == ""
          ) {
            this.addType = true;
            this.$toast(this.$t('inform.contentToastText'));
            return;
          }

          let _this = this;
          let mode = "add";
          let data = {
            baseFiles: this.informMsg.baseFiles,
            content: this.informMsg.content,
            title: this.informMsg.title,
            regionCode: this.userinfo.zqCode,
            regionLevel: this.getLevel(this.userinfo.zqCode),
            enable: true,
            isTop: true
          };
          _this.$api.inform
            .saveInform(mode, data)
            .then(res => {
              if (res.code == "1") {
                _this.$toast(_this.$t('common.issueTip'));
                setTimeout(function() {
                  //将当前页面关闭
                  if (_this.clientType == "android") {
                    //安卓
                    window.android.getInfo(106,"2");
                  } else {
                    //IOS
                    window.webkit.messageHandlers.closePage.postMessage("2");
                  }
                }, 3000);
              } else {
                this.addType = true;
                _this.$toast(res.msg);
              }
            })
            .catch(err => {
              this.addType = true;
              console.log(err);
            });
        } else {
          this.$toast(_this.$t('common.moreClickToastMsg'));
        }
      }
    },
    getLevel(num) {
      let level = "";
      if (num.length == "2") {
        level = 1;
      } else if (num.length == "4") {
        level = 2;
      } else if (num.length == "6") {
        level = 3;
      } else if (num.length == "9") {
        level = 4;
      } else {
        level = 5;
      }
      return level;
    },
    cancelText(changeLeftType) {
      this.selecLeftType = changeLeftType;
    }
  },
  computed: {
    ...mapState(["userinfo"])
  },
  watch: {
    userinfo: {
      handler: function() {
        console.log(JSON.stringify(this.userinfo));
        // this.getRichText();
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.editInformPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 10px;
  position: relative;
  .forestInput {
    padding: 0 10px;
    .van-cell {
      .van-field__label {
        span {
          color: #666;
          font-size: 16px;
        }
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  //富文本及图片上传
  .ggMainEditor {
    width: 100%;
    margin-top: 10px;
    padding: 10px 10px;
    .van-cell {
      .van-field__label {
        span {
          color: #666;
          font-size: 16px;
        }
      }
      .van-cell__title {
        width: 200px;
      }
    }
    .van-cell:not(:last-child)::after {
      display: none;
    }
    .richText {
      padding: 0 16px;
      position: relative;
      .ggMainDetail {
        width: 100%;
        height: 260px;
        padding: 5px 5px;
        overflow-y: scroll;
        border: 1px solid #f6f6f6;
        color: #333;
        font-size: 12px;

        img {
          max-width: 100% !important;
          margin: 0 auto;
          display: block;
        }
      }
      .contentPlaceholder {
        color: #999;
        font-size: 14px;
        position: absolute;
        top: 10px;
        left: 25px;
      }
    }
  }
  .historyMain.ggMainEditor {
    .van-cell {
      padding: 0 16px;
      .van-cell__title {
        width: 200px;
      }
      .van-field__control {
        color: #333;
        font-size: 14px;
        text-align: right;
      }
    }
  }
  .uploadingFiles {
    width: 100%;
    padding: 15px 16px;
    background-color: #fff;
    margin-top: 10px;
    position: relative;
    h4 {
      font-weight: 400;
      font-size: 16px;
      color: #666;
    }
    > a {
      font-size: 14px;
      position: absolute;
      right: 16px;
      top: 15px;
      color: #08b9fb;
    }
    .listItem {
      .item {
        margin: 10px 0;
        padding: 0;
        border-bottom: 1px solid #f6f6f6;
        min-height: 50px;
        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;

            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              -webkit-border-radius: 5px;
              -moz-border-radius: 5px;
            }
          }

          dd {
            display: block;
            font-size: 10px;
            color: #999;
            position: absolute;
          }

          dd.dtName {
            font-size: 14px;
            color: #666;
            top: 0px;
            left: 48px;
          }
          dd.Mb {
            top: 17px;
            left: 48px;
          }
          //   dd:nth-child(3) {
          //     top: 15px;
          //     left: 35px;

          //     span {
          //       display: inline-block;
          //       margin-left: 8px;
          //     }
          //   }
        }
        a.deleteBtn {
          margin-right: 12px;
          margin-top: 10px;
          i {
            font-size: 22px;
          }
        }
      }
    }
  }
  .clssifyPicker.van-popup {
    width: 100%;
    height: 100%;
    padding-top: 5px;
  }
}
</style>